import usersController from '../users.controller';

class usersListController extends usersController{
  /**
   *
   * @param $users
   * @param CONFIG
   */
  constructor(
    $users,
    $companies,
    $rootScope,
    $uibModal,
    CONFIG,
  ){
    'ngInject';
    super( $users, $companies, $rootScope, $uibModal );
    this.$users.setUri( `${CONFIG.API.users}/` );
  }

}

export default usersListController;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users-list/users-list.controller.js
 **/